import Container from '@atoms/Container';
import React from 'react';
import ArticleCard from '@sections/ArticleCard';
import paddingDefault from '../utils/paddingDefault';
import { colors } from '../primitives/colors';

const FranchiseBlogSection = ({ data }): JSX.Element | null => {
    if (!data || data?.length === 0) {
        return null;
    }

    return (
        <div css={[paddingDefault(), styles.containerWrap]}>
            <Container>
                <h2 css={styles.blogrollHeading}>Recommended For You</h2>
                <ul css={styles.blogrollGrid}>
                    {!!data
                        && data?.length > 0
                        && data.map((item) => {
                            const articleData = {
                                title: item.blogTitle,
                                content: item.blogExcerpt || item.blogContent,
                                url: item.blogPermaLink,
                            };
                            return (
                                <li css={styles.blogrollGridItem} key={item.blogTitle}>
                                    <ArticleCard htmlContent article={articleData} />
                                </li>
                            );
                        })}
                </ul>
            </Container>
        </div>
    );
};

const styles = {
    containerWrap: {
        background: colors.shadesWhite
    },
    blogrollHeading: {
        marginBottom: "1rem",
        lineHeight: 1.25,
        textAlign: "center",
        fontSize: "32px",
        "@media (min-width: 1024px)": {
            marginBottom: "1.5rem",
        }
    },
    blogrollGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        gap: "2rem",
        "@media (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            rowGap: "4rem"
        },
        "@media (min-width: 1024px)": {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        },
    },
    blogrollGridItem: {
        flex: "1 1 auto",
        width: "100%"
    }
};

export default FranchiseBlogSection;
